import React from 'react';
import { InView } from 'react-intersection-observer';
import ProductHeader from './product-header';
import { ProductPageQuery } from '../../../../types';

const ProductPageHeader: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IProductPageHeaderProps>
>> = props => {
  const { product, setHeaderVisible, isHeaderVisible, currentCampaign } = props;
  if (!product) {
    return null;
  }

  const onHeaderVisibilityChange = (isVisible: boolean) => {
    if (isHeaderVisible !== isVisible) {
      setHeaderVisible(isVisible);
    }
  };

  return (
    <InView onChange={onHeaderVisibilityChange}>
      <ProductHeader
        title={product.name}
        product={product}
        currentCampaign={currentCampaign}
      />
    </InView>
  );
};

interface IProductPageHeaderProps {
  product: ProductPageQuery['product'];
  isHeaderVisible: boolean;
  setHeaderVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentCampaign: any;
}

export default ProductPageHeader;
